
class CustomTabs extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      tabLinks: this.querySelectorAll(".tab-header"),
      tabPages: this.querySelectorAll(".tab-page"),
    }

    // Parse URL to get the tab class name from the 'tab' parameter
    const params = new URLSearchParams(window.location.search);
    const tabClassName = params.get('tab'); // 'tab' is the URL parameter name

    // If the tabClassName exists, show the corresponding tab
    if (tabClassName) {
      this.showTabByClass(tabClassName);
      setTimeout(() => {
        document.querySelector(`.tabs-container .${tabClassName}`).click();
      }, 2000);
    } else {
      let firstIndex = 0;
      this.showTabByIndex(firstIndex);
    }

    Array.from(this.elements.tabLinks).forEach((tabLink) => {
      tabLink.addEventListener("click", (event) => {
        const tabIndex = event.target.id.split("_")[1] - 1;
        this.showTabByIndex(tabIndex);
      });
    });
  }

  showTabByClass(className) {
    const tabIndex = Array.from(this.elements.tabLinks).findIndex(tabLink => tabLink.classList.contains(className));
    if (tabIndex > -1) {
      this.showTabByIndex(tabIndex);
    }
  }

  showTabByIndex(tabIndex) {
    Array.from(this.elements.tabPages).forEach((tabPage) => tabPage.classList.remove("active"));
    Array.from(this.elements.tabLinks).forEach((tabLink) => tabLink.classList.remove("active"));
    this.elements.tabPages[tabIndex].classList.add("active");
    this.elements.tabLinks[tabIndex].classList.add("active");
  }
}

customElements.define('custom-tabs', CustomTabs);